import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons/faArrowRight';
import colors from '../../../helpers/colors';

const CTAButton = styled.a`
    text-transform: uppercase;
    font-size: 15px;
    font-weight: bold;
    color: ${({ color }) => color};
    cursor: pointer;
    transition: .3s;
    text-decoration: none;

    &:hover {
        color: ${colors.mvDarkerBlue};
        transition: .3s;
    }
`;

CTAButton.defaultProps = {
    color: colors.mvMediumGrey
};

const CTA = ({ctaHref, ctaText, color}) => {
    return (
        <CTAButton href={ctaHref} color={color}>
            {ctaText}
            <FontAwesomeIcon icon={faArrowRight} style={{ marginLeft: '10px' }} className='icon' alt="Arrow pointing to the right" />
        </CTAButton>
    )
}

export default CTA;
